import React from 'react';
import {ReportSummaryInterface, type ReportSummaryParamType} from "../../../types/common/ReportSummaryInterface";
import {ReportSummaryLoader} from "./ReportSummaryLoader";
import {formatCurrencyValue} from "../../../util/PaymentUtils";
import {withLoader} from "../../hocs/withLoader";
import {
  GroupSummariesCardContainer
} from "@securspace/securspace-ui-kit";
import {
  GroupSummariesCardItem,
  GroupSummariesCardFullScreen
} from "../../cardComponents";

export type ReportSummaryMappingFormatterType = 'currency' | 'number' | 'percentage' | 'text';

export interface ReportSummaryMapping {
  id: string;
  label: string;
  formatter?: ReportSummaryMappingFormatterType
}

interface ReportSummaryProps {
  mapping: ReportSummaryMapping[];
  summary?: ReportSummaryInterface;
}

const formatValue = (value: ReportSummaryParamType, formatter?: ReportSummaryMappingFormatterType) => {
  if (value === null || value === undefined) {
    return '-';
  }
  switch (formatter) {
    case 'currency':
      return (['number', 'string'].includes(typeof value)) ? formatCurrencyValue(value as 'number' | 'string', true) : value;
    case 'number':
      return value.toLocaleString();
    case 'percentage':
      return (typeof value === 'number') ? `${(value * 100).toFixed(0)}%` : "0%";
    case 'text':
    default:
      return value;
  }
}

/**
 * Component to display aggregated values for grouped SupplierActivitySummaries
 * @param mapping the ReportSummaryMapping that dictates how the summary is formatted for display
 * @param summary the aggregated values/labels to display
 * @constructor
 */

const ReportSummary = ({
  mapping,
  summary
}: ReportSummaryProps) => {

  const hasSummaryData =
          !!summary &&
          Object.keys(summary).length > 0 &&
          Array.isArray(mapping) &&
          mapping.length > 0;

  if (!hasSummaryData) {
    return null;
  }

  return <GroupSummariesCardFullScreen>
    <GroupSummariesCardContainer>
      {
        mapping.map((mappingItem) => {
          return <GroupSummariesCardItem
            key={mappingItem.id}
            title={mappingItem.label}
            value={formatValue(summary[mappingItem.id], mappingItem.formatter)}
          />
        })
      }
    </GroupSummariesCardContainer>
  </GroupSummariesCardFullScreen>
}

const ReportSummaryWithLoader = withLoader(ReportSummary, ReportSummaryLoader);

export { ReportSummaryWithLoader };
